import { Button } from '../../ui/button';
import DealDeliveryPreferenceSelector, {
  type DealDeliveryPreferenceSelectorProps,
} from './deal-delivery-preference-selector';

// DEV NOTE: this is just a wrapper around the DealDeliveryPreferenceSelector component
// that is used to make the button look like a button
export function DealDeliveryPreferenceSelectorButton(
  props: DealDeliveryPreferenceSelectorProps,
) {
  return (
    <Button variant="outline" className="p-0 h-fit">
      <DealDeliveryPreferenceSelector {...props} />
    </Button>
  );
}

export default DealDeliveryPreferenceSelectorButton;
